module.exports = __webpack_public_path__ + "img/6.e7a931d0.png";